<template>
  <div class="content">
    <div class="container-fluid">
        <div class="row" v-if="true">
          <div class="col-12">
              <div slot="content">
                DU 
              </div>
           </div>   
        </div>   
    </div>
  </div>
</template>

<script>

const Business = require('ppe-business')

export default {
    data () {
      return {
        Catalog : Business.DUCatalog,
        data : {},
        
      }},
      mounted() {
      this.$http.get(`/du/document?id=${this.$route.params.id}`)
        .then(response => {
          console.log("/du/document", response.data)
          this.data = response.data
          this.$emit("on-title", this.data.document.Company.Name)
          this.$eventbus.$emit("on-title", this.data.document.Company.Name)
        })
        .catch(err => {
            console.error("/du/document", ""+err)
        })
    },
    methods:{

    }
}

</script>